import { toBigWithDefault, useCallbackRef, type NumberInputProps, type NumericField } from '@talos/kyoko';
import { useMemo } from 'react';
import { PricingNumberInput } from './PricingNumberInput';

type PricingQtyNumberInputProps = {
  field: NumericField;
  errorString?: string;
} & Omit<NumberInputProps, 'value' | 'disabled' | 'prefix' | 'variant'>;

export const PricingQtyNumberInput = ({ field, errorString, ...numberInputProps }: PricingQtyNumberInputProps) => {
  const increment = useMemo(() => toBigWithDefault(numberInputProps.minIncrement, 1), [numberInputProps.minIncrement]);
  const canStep = increment.gt(0);
  const tooltip = errorString ?? field.errorString;

  const handleIncrement = useCallbackRef(() => {
    const nextValue = toBigWithDefault(field.value, 0).plus(increment);
    numberInputProps.onChange(nextValue.toFixed());
  });

  const handleDecrement = useCallbackRef(() => {
    const nextValue = toBigWithDefault(field.value, 0).minus(increment);
    numberInputProps.onChange(nextValue.toFixed());
  });

  return (
    <PricingNumberInput
      field={field}
      showIncrementDecrementButtons
      incrementDecrementButtonsDisabled={!canStep}
      onIncrement={handleIncrement}
      onDecrement={handleDecrement}
      tooltip={tooltip}
      iconVariant={tooltip ? 'colorTextNegative' : undefined}
      {...numberInputProps}
    />
  );
};
